const ROLE_TABLE = {
    "nenda-admin": {
        label: "Nenda admin",
        levels: {
            premises: "administrate",
            units: "administrate",
            screens: "administrate",
            "software-updates": "administrate",
            signage: "administrate",
            "signage-templates": "administrate",
            media: "administrate",
            "tv-layout": "administrate",
            "guest-web": "administrate",
            offers: "administrate",
            "guest-requests": "administrate",
            "pms-link": "administrate",
            statistics: "administrate",
            residents: "administrate",
            "audit-log": "view",
            "video-calls": "administrate",
            licences: "administrate",
            companies: "administrate",
            users: "administrate",
            distribution: "administrate",
            "supplier-trust": "administrate",
            "content-owners": "administrate",
            storefront: "administrate",
            "global-settings": "administrate",
            "client-errors": "administrate",
            demos: "administrate",
            "sales-videos": "administrate",
        },
    },
    manager: {
        label: "Manager",
        levels: {
            premises: "edit",
            units: "edit",
            screens: "edit",
            signage: "edit",
            "signage-templates": "edit",
            media: "edit",
            "tv-layout": "edit",
            "guest-web": "edit",
            offers: "edit",
            "guest-requests": "edit",
            statistics: "view",
            residents: "edit",
            "video-calls": "edit",
            licences: "view",
            companies: "view",
        },
    },
    viewer: {
        label: "Viewer",
        levels: {
            premises: "view",
            units: "view",
            screens: "view",
            signage: "view",
            "signage-templates": "view",
            media: "view",
            "tv-layout": "view",
            "guest-web": "view",
            offers: "view",
            "guest-requests": "view",
            statistics: "view",
            licences: "view",
            companies: "view",
        },
    },
    "content-owner": {
        label: "Content owner",
        levels: {
            "distribution/titles": "edit",
            "content-owners": "edit",
            storefront: "edit",
        },
    },
};
export const ROLES = ROLE_TABLE;
export const ROLE_NAMES = Object.keys(ROLES);
export function isRoleName(value) {
    return (typeof value === "string" &&
        Object.prototype.hasOwnProperty.call(ROLES, value));
}
